import { ValueGetter, ValueOrValueGetter } from './types';

export default function getValue<T>(value: ValueOrValueGetter<T>) {
    return isValueGetter(value) ? value() : value;
}

function isValueGetter<T>(value: ValueOrValueGetter<T>): value is ValueGetter<T> {
    return typeof value === 'function';
}
